import axios from "axios";
// import { commonHeaders } from "services/httpClient/commonHeader";

// import { RequestVehicleInspection, vehicleDocsSchema } from "styles/types/vehicle";
import TokenService from "../../services/httpClient/tokenManager";
import paymentClient from "services/httpClient/paymentClient";
import { API_BASE_URL } from "config";
// import accountClient from "services/httpClient/accountClient";
// import { SendDeviceProp } from "styles/types/device";


const  authHeader =() => {
  const token = TokenService.getLocalAccessToken();

  if (token) {
    return {
      Authorization: "Bearer " + token,
      "Content-Type": "application/json",
      'Access-Control-Allow-Origin':'*',
    };
  } 
}

// const baseURL= `https://digitallending.accessbankplc.com:9091`
const baseURL= API_BASE_URL
// const headers= commonHeaders

export const getPaymentInfo = (paymentCode: any) => {
  return paymentClient.get(`/api/Payment/info/${paymentCode.paymentCode}`);
};

// const user = JSON.parse(sessionStorage.getItem("userData") || "{}");
  



export const getPayLaterVendors = async () => {
  return await axios.get(
    `${baseURL}/api/Payment/pay-later-vendors?page=1&limit=10`,
    {
      headers:authHeader(),
    }
  ).then((response) => {
    return response.data;

  });
};

export const createPayLaterRequest = async (body: any) => {
  return await axios.post(
    `${baseURL}/api/Payment/finalize`,body,
    {
      headers:authHeader(),
    }
  ).then((response) => {
    return response.data;
  });
};


export const createPayLaterInspection = async (body: any) => {
  return await axios.post(
    `${baseURL}/api/Payment/save-payment`,body,
    {
      headers:authHeader(),
    }
  ).then((response) => {
    return response.data;
  });
};

export const payLaterMonthlyRepay = async (body: any) => {
  return await axios.post(
    `${baseURL}/api/Loan/paylater-monthly-repayment`,body,
    {
      headers:authHeader(),
    }
  ).then((response) => {
    return response.data;
  });
};